export const isPositiveNumber = (input: unknown): input is number => {
  return (
    !isNaN(input as number) &&
    typeof input !== 'string' &&
    (input as number) >= 0
  );
};

export const parseIntOrUndefined = (input: unknown): number | undefined => {
  if (typeof input === 'number') {
    return input;
  }
  if (typeof input === 'string') {
    const result = parseInt(input);

    if (isNaN(result)) {
      return undefined;
    }

    return result;
  }
  return undefined;
};

export const getCheckedKeys = (input: Record<string, boolean>): string[] => {
  const checkedKeys: string[] = [];
  for (const key in input) {
    if (Object.prototype.hasOwnProperty.call(input, key) && input[key]) {
      checkedKeys.push(key);
    }
  }
  return checkedKeys;
};
